import React from 'react';
// Components
import { AppImage, FileThumbnail } from '@components';
import { Tooltip, TooltipProps, styled, tooltipClasses } from '@mui/material';

interface iSingleFilePreview {
  file: any;
}

const BootstrapTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} arrow classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.arrow}`]: {
    color: theme.palette.common.black,
  },
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.palette.common.black,
  },
}));

const SingleFilePreview: React.FC<iSingleFilePreview> = ({ file }) => {
  if (!file) {
    return null;
  }

  // @ts-ignore
  const imgUrl = typeof file === 'string' ? file : file.preview;

  return (
    <BootstrapTooltip title={file.name}>
      {file?.type === 'application/pdf' ? (
        <FileThumbnail file={file} />
      ) : (
        <AppImage
          alt={file.name}
          src={imgUrl}
          ratio="16/9"
          sx={{
            borderRadius: 1,
            overflow: 'hidden',
          }}
        />
      )}
    </BootstrapTooltip>
  );
};

export default SingleFilePreview;
